var exports = {
  "kL": "x804f0401--399ff8--container",
  "DD": "x804f0401--399ff8--title",
  "mJ": "x804f0401--399ff8--textfield",
};

module.exports = exports;
